<div class="radial-container">
  @for (layer of layers(); track layer; let li = $index) {
    <div class="circle-layer"
         [style.width.px]="200 + li * 150"
         [style.height.px]="200 + li * 150"
         [style.z-index]="layers().length-li">
      <div class="member-container">
        @for (member of layer; let i = $index; track i; ) {
          <div class="member"
               [style.transform]="'rotate(' + (360 / layer.length * i - li*150) + 'deg)'"
               [style.transform-origin]="(200 + li * 150)/2 + 25 + 'px'"
               (mouseenter)="activeMember = member"
               (mouseleave)="activeMember = null">
            <img class="ava"
                 [src]="member?.foto1?.url"
                 [style.--angle]="-(360 / layer.length * i - li * 150) + 'deg'"/>
          </div>
        }
      </div>
    </div>
  }
  <div class="member-info" [class.show]="activeMember">
    <div class="info-content">
      <h2>{{ activeMember?.full_name }}</h2>
      <p>{{ activeMember?.specialization }}</p>
    </div>
    <img [src]="activeMember?.foto2?.url" class="cartoon_img">
  </div>
</div>
